import classNames from 'classnames';
import React from 'react';
import sendosoBlackImage from 'assets/svg/sendoso-black.svg';
import ss from './footer-main.sendoso.scss';
export const FooterMain = ({
  footerClassName = ''
}) => /*#__PURE__*/React.createElement("div", {
  className: classNames(ss.footer, footerClassName)
}, /*#__PURE__*/React.createElement("img", {
  src: sendosoBlackImage,
  alt: "logo"
}), /*#__PURE__*/React.createElement("span", {
  className: ss.copyright
}, "\xA9 ", new Date().getFullYear(), " Sendoso. All Rights Reserved."));